import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "type", "value", "disallowFuture", "disallowPast", "dataTest"];
import React from 'react';
import DatePicker from 'react-date-picker';
import DateTimePicker from 'react-datetime-picker';
import './styles.css';
var DateTimeInput = function DateTimeInput(_ref) {
  var onChange = _ref.onChange,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'datetime-local' : _ref$type,
    value = _ref.value,
    _ref$disallowFuture = _ref.disallowFuture,
    disallowFuture = _ref$disallowFuture === void 0 ? false : _ref$disallowFuture,
    _ref$disallowPast = _ref.disallowPast,
    disallowPast = _ref$disallowPast === void 0 ? false : _ref$disallowPast,
    dataTest = _ref.dataTest,
    props = _objectWithoutProperties(_ref, _excluded);
  var change = function change(date) {
    return onChange(date);
  };
  if (value && typeof value === 'string') {
    value = new Date(value);
    value = Number.isNaN(value.valueOf()) ? '' : value;
  }
  if (value instanceof Date === false) {
    value = '';
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest || 'datetime-input'
  }, type === 'datetime-local' && /*#__PURE__*/React.createElement(DateTimePicker, _extends({}, props, {
    onChange: change,
    value: value,
    disableClock: true,
    clearIcon: null,
    calendarIcon: "\u25BC"
  }, disallowPast && {
    minDate: new Date()
  }, disallowFuture && {
    maxDate: new Date()
  })), type === 'date' && /*#__PURE__*/React.createElement(DatePicker, _extends({}, props, {
    onChange: change,
    value: value,
    clearIcon: null,
    calendarIcon: "\u25BC"
  }, disallowPast && {
    minDate: new Date()
  }, disallowFuture && {
    maxDate: new Date()
  })));
};
export default DateTimeInput;
//# sourceMappingURL=index.js.map
